import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

//OBTIENE LOS INGRESOS POR FECHA 
export const ObtenerIngresosDetalle = async (data) => {
  return await PrivateInterceptor('Suministros/IngresosBodegaDetalle/IngresosDetallePorFecha', 'POST', data);
}

//OBTIENE LOS INGRESOS 
export const ObtenerIngresosT = async () => {
  return await PrivateInterceptor('Suministros/IngresosBodegaDetalle/ObtenerIngresosT', 'GET');
}

//OBTIENE LOS INGRESOS 
export const ObtenerIngresosSinEliminar = async () => {
  return await PrivateInterceptor('Suministros/IngresosBodegaDetalle/DetallesIngresoSinEliminar', 'GET');
}

// OBTIENE LOS DETALLES DE LOS INGRESOS POR NO.INGRESO
export const ObtenerDetalleIngresos = async (NumeroIngreso) => {
  const result = await PrivateInterceptor(`Suministros/IngresosBodegaDetalle/ObtenerDetalleIngresos`, 'POST', {NumeroIngreso} )
  return result;
}

// GUARDAR INGRESOS
export const GuardarIngreso = (data, data2) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/GuardarIngreso", "POST", {Encabezado: data, Detalle: data2});
  return respuesta;
};

// GUARDAR INGRESOS
export const EditarIngreso = (data, data2) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/EditarIngreso", "POST", {Encabezado: data, Detalle: data2});
  return respuesta;
};

export const GuardarIngresoSINPO = (data, data2) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/GuardarIngresoSINPO", "POST", {Encabezado: data, Detalle: data2});
  return respuesta;
};

export const EditarIngresoSINPO = (data, data2) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/EditarIngresoSINPO", "POST", {Encabezado: data, Detalle: data2});
  return respuesta;
};

// ELIMINAR ITEM DE INGRESO
export const EliminarItemIngreso = (Encabezado, data) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/EliminarItemIngreso", "POST",{Encabezado, Detalle: data});
  return respuesta;
};

// ELIMINAR INGRESO
export const EliminarIngreso = (Encabezado, Detalle) => {
  const respuesta = PrivateInterceptor(
    "Suministros/IngresosBodegaDetalle/EliminarIngreso",
    "POST",
    { Encabezado, Detalle }
  );
  return respuesta;
};

//OBTIENE LISTADO DE INGRESOS BODEGA
export const DetallesIngresosBodega = () => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle", "GET");
  return respuesta;
};

//OBTIENE LOS INGRESOS POR FECHA PARA HACER DEVOLUCIONES
export const ObtenerIngresosParaDevoluciones= async (data) => {
  return await PrivateInterceptor('Suministros/IngresosBodegaDetalle/IngresosDetalleParaDevoluciones', 'POST', data);
}

export const cambiarExcentoDet = (datos) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/CambiarExcentoDet", "POST", {datos});
  return respuesta;
};

export const cambiarRevisadoBodega = (IdIngreso) => {
  const respuesta = PrivateInterceptor(
    "Suministros/IngresosBodegaDetalle/CambiarRevisadoBodega", "POST", { IdIngreso });
  return respuesta;
};

export const cambiarEstadoRevisado = (IdIngreso) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/CambiarEstadoRevisado", "POST", {IdIngreso});
  return respuesta;
};

export const cambiarRecibidofinanzas = (IdIngreso, IdUserRecibioFin) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/CambiarRecibidofinanzas", "POST", {IdIngreso, IdUserRecibioFin});
  return respuesta;
};

export const cambiarRecibidoCompras = (IdIngreso) => {
  const respuesta = PrivateInterceptor("Suministros/IngresosBodegaDetalle/CambiarRecibidoCompras", "POST", {IdIngreso});
  return respuesta;
};

// CAMBIO MANUAL DE ESTADO DE REVISIÓN - ADMIN
export const cambiarEstadoRevisionAdmin = ( IdIngreso, IdEstadoRevisado) => {
  const respuesta = PrivateInterceptor(
    "Suministros/IngresosBodegaDetalle/CambiarEstadoRevisionAdmin", "POST",
    {
      IdIngreso,
      IdEstadoRevisado,
    }
  );
  return respuesta;
};

export const getIngresosServicios = async() => {
  const result = await PrivateInterceptor('Suministros/IngresosBodegaDetalle/getIngresosServicios', 'GET')
  return result;
}

export const volverARecibido = async(IdIngreso) => {
  const result = await PrivateInterceptor('Suministros/IngresosBodegaDetalle/volverARecibido', 'POST', {IdIngreso})
  return result;
}

export const getOrdenesEnTransito = async(IdPurchaseOrder) => {
  const result = await PrivateInterceptor('Suministros/IngresosBodegaDetalle/getOrdenesEnTransito', 'POST', {IdPurchaseOrder})
  return result;
}

export const asignarCuentaEnTransito = async(data) => {
  const result = await PrivateInterceptor('Suministros/IngresosBodegaDetalle/AsignarCuentaTransito', 'POST', {data})
  return result;
}

